import { eventBus } from '@/shared/EventBus';
import { useGameStore } from '@/ui/store/gameStore';

export function HalloweenBossIntroControls() {
  const active = useGameStore(s => s.bossIntroActive);
  const teleporting = useGameStore(s => s.isTeleporting);
  if (!active || teleporting) return null;
  return <div role="dialog" aria-label="Dyniowe intro" className="absolute inset-0 z-50 pointer-events-none">
    <button autoFocus className="absolute right-4 top-4 rounded-full border-2 border-white/70 bg-[#5f426b]/90 px-5 py-3 font-bold text-white shadow-lg pointer-events-auto focus-visible:outline focus-visible:outline-4 focus-visible:outline-amber-300"
      onClick={() => eventBus.emit('halloweenBoss:introSkip', {})}>Pomiń <span aria-hidden="true">›</span></button>
  </div>;
}
